import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { AppProps } from '@/App'
import Button from '@/components/Button/Button'
import { useAppState } from '@/composables/useAppState'
import { AppChooseEvent } from '@/state/AppEvent'

import UIText from '../UI/UIText'

export default function Idle({ persona = 'pedro', relationship = 'CHILD', interestedBy = undefined }: AppProps) {
  const { actor } = useAppState()
  const { t } = useTranslation()

  const isLockedPersona = import.meta.env.VITE_LOCKED_PERSONA ? import.meta.env.VITE_LOCKED_PERSONA.split(',') : []

  const onChoose = useCallback(
    (persona: string) => {
      actor.send({
        type: 'CHOOSE',
        persona,
        relationship,
        interestedBy: interestedBy ? interestedBy : t(`child.${persona}.difference`),
      } as AppChooseEvent)
    },
    [actor, relationship, interestedBy, t]
  )

  return (
    <div
      data-testid='idle'
      className='col-span-1 col-start-1 row-span-1 row-start-1 p-20 md:p-0 relative w-full min-h-dvh md:h-screen flex items-center justify-center'
    >
      <div className='mt-4 flex flex-col items-center justify-center gap-16'>
        <div className='flex flex-col items-center justify-center'>
          <UIText is='h2' i18nKey={`idle.title`} className='text-heading-h3 text-center' delay={0.3} />
          <UIText is='p' i18nKey={`idle.text`} className='text-center text-body-s' delay={0.4} />
        </div>
        <div className='flex flex-wrap gap-8 mt-4 items-center justify-center'>
          <Button
            appear
            appearDelay={0.5}
            hasParticles={true}
            onClick={() => onChoose('pedro')}
            disabled={isLockedPersona.includes('pedro')}
            className={`${isLockedPersona.includes('pedro') ? 'opacity-30' : ''}`}
          >
            {t('child.pedro.name')}
          </Button>
          <Button
            appear
            appearDelay={0.6}
            hasParticles={true}
            onClick={() => onChoose('caris')}
            disabled={isLockedPersona.includes('caris')}
            className={`${isLockedPersona.includes('caris') ? 'opacity-30' : ''}`}
          >
            {t('child.caris.name')}
          </Button>
          <Button
            appear
            appearDelay={0.7}
            hasParticles={true}
            onClick={() => onChoose('francesca')}
            disabled={isLockedPersona.includes('francesca')}
            className={`${isLockedPersona.includes('francesca') ? 'opacity-30' : ''}`}
          >
            {t('child.francesca.name')}
          </Button>
        </div>
      </div>
    </div>
  )
}
